export const defaultFilters = {
  programTypeFilters: [],
  diagnosisNames: [],
  diagnosisCodes: [],
  rxnormDrugsFilter: [],
  insuranceTypes: [],
  states: [],
  openedFunds: null
};
